import { SEARCH_DISPLAY_NAME } from "./core";
import createTestId from "../../../fabrics/createTestId";

export const createTestIdForSearchElement = createTestId(SEARCH_DISPLAY_NAME);
